Greenmile.Survey.Sidebar.EntityGridCache = function (entity) {

    var gridActionsSelector = '#SurveyLinkForm div.questionContent div.gridActionsCache.ui-widget-header';
    var gridContainerSelector = '#SurveyLinkForm .questionContent .content .gridContainerCache';
    var entityToActionGrid = entity;
    var customNamespace = 'SurveyQuestionEntityCached';

    this.setQuestionData = function (question) {
        this.question = question;
    };

    this.getGridOptions = function (layoutIndex) {

        var options = {
            entity: customNamespace,
            columnCheckBox: {
                show: true,
                checkBoxEventClass: [Monet.Grid.ActionsModules.BatchDelete],
                btnSelector: '#SurveyLinkForm div.questionContent div.gridActionsCache #buttonEventCheckBox',
                options: {
                    checkOnClickRow: true
                }
            },
            columnEdit: {
                show: false
            },
            actions: [],
            gridActionsSelector: gridActionsSelector,
            entityToActionGrid: entityToActionGrid,
            gridContainner: gridContainerSelector,
            multiColumnSort: true,
            multiSelect: false,
            sortBy: 'client',
            frozenColumn: Monet.Grid.getIndexFrozenColumn(layoutIndex)
        };

        return options;
    };

    var setCacheData = function (collection) {
        var cacheGrid = App.Forms[customNamespace].table;
        var gridDataLength = cacheGrid.getData().data.length;
        var MAX_NUMBER_TO_IN_ON_ORACLE = 1000;

        if (gridDataLength > MAX_NUMBER_TO_IN_ON_ORACLE) {
            new Greenmile.Components.AlertModal('Survey.cacheIsAlreadyFull')
                .show();
        }

        var refreshGrid = function () {
            cacheGrid.setSelectedRows([]);
            cacheGrid.invalidateAllRows();
            cacheGrid.resizeCanvas();
        };

        if (gridDataLength) {
            Monet.Grid.appendDataToGrid(customNamespace, cacheGrid.getColumns(), collection);
            refreshGrid();

        } else {
            Monet.Grid.addDataToGrid(customNamespace, cacheGrid.getColumns(), collection, false);
        }

        App.Objects[customNamespace] = {
            batchDelete: function (idsToDelete) {

                if (cacheGrid) {
                    for (var i in idsToDelete) {
                        App.Forms[customNamespace].dataProvider.deleteItemById(customNamespace + '_' + idsToDelete[i]);
                    }

                    if (cacheGrid.getData().data.length) {
                        refreshGrid();
                    } else {
                        App.Forms.SurveyQuestionEntityCached.gridCache.destroy();
                        cacheGrid = null;
                    }
                }

            }.bind(this)
        };
    };

    this.destroy = function () {
        var cacheGrid = App.Forms[customNamespace].table;
        var btnDelete = document.querySelector('.gridActionsCache.ui-widget-header .eventCheckBox.gridActionDiv');
        if (btnDelete) {
            cacheGrid.destroy();
            btnDelete.parentElement.removeChild(btnDelete);
        }
    };

    this.addItems = function (models) {
        var collection = new App.Collections[entityToActionGrid + 's']();
        collection.add(models);
        setCacheData(collection);

    };

    this.cacheResults = function (table) {
        var gridSelected = table.getItemsSelected().map(function (item) {
            return item.attributes;
        });

        var collection = new App.Collections[entityToActionGrid + 's']();
        if (this.question && this.question.entityRestriction) {
            collection.filterWithRestrictions({
                filter: JSON.parse(this.question.entityRestriction),
                criteria: JSON.stringify(JSON.parse(this.question.entityProjection)),
                success: function (data) {
                    data.add(gridSelected);
                    setCacheData(data);
                }.bind(this)
            });

        } else if (gridSelected && gridSelected.length) {
            collection.add(gridSelected);
            setCacheData(collection);
        }
    };

    this.createGrid = function () {

        var columns,
            dataView,
            grid,
            options,
            layoutIndex = App.Forms.SurveyQuestionEntity.layout.index;

        options = this.getGridOptions(layoutIndex);
        columns = Monet.Grid.getGridLayout(layoutIndex, 'SurveyQuestionEntity');
        dataView = new Monet.Grid.DataProvider(columns, null, customNamespace);

        var btnDelete = document.querySelector('.gridActionsCache.ui-widget-header .eventCheckBox.gridActionDiv');
        if (btnDelete) {
            btnDelete.parentElement.removeChild(btnDelete);
        }
        grid = new Monet.Grid.GenericGrid(gridContainerSelector, dataView, columns, options);

        App.Forms[customNamespace] = { gridCache: this };
        App.Forms[customNamespace].table = grid;
        App.Forms[customNamespace].dataProvider = dataView;

    };

};